module.exports = __webpack_public_path__ + "img/top-bar.df432ab8.png";